// SignInPage.js
import React from "react";

import MemberUpdate from "../components/member/sign-up/MemberUpdate";

const MemberUpdatePage = () => {
  return <MemberUpdate />;
};

export default MemberUpdatePage;
